var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2194_94",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2194_94",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAABWklEQVR4nO3bPWoDMRCG4WlziWBys+ly6ASzB3GcxoIU+QHbMZ9WzwvbqpiHKVagKkmSJEmSJEmSJEmSJEmSVE9mkDPD56p6q6rXex24YF1Vx6p6uQfGe1Wdq+oDytUYp8sMt1tQvmKMD8r1GOdbUL7DgHI7xtUov4HYlNsw/mVLoDwYYwQlCGMEJQhjBCUIYwQlCGMEJQhjBCUIY7Q6SidhrI7SiRironQyxmooPQPGKig9E8beUXpGjL2i9MwYe0PpPWDsBaX3hDE7Su8RY1aU3jPGbCi9AsYsKL0SRjpKr4iRitIrY6ShNIwclIaRg9IwclAaRg5Kw8hBaRg5KA0jB6Vh5KA0jByUhpGD0jByUBpGDkrDeFyHyzvvn1BOf9zaHi9n6IGbcl75Cn0WlA1GDsoGIwdlg5GDssHIQdlg5KBsMHI6+M+QJEmSJEmSJEmSJEmSJKny+wQrgMS1KLj4wAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.6c803e14456db513a85ced8be95feff0.svg";
export { ForwardRef as ReactComponent };